import { browserAlertsEnabled, browserAlertsRegistration } from './browser-trade-alerts';
import { amount, usd } from './format';
import type { PremiumNotification } from './premium-context';

export function premiumNoticeText(notice: PremiumNotification) {
  const trade = notice.trade[0];
  if (trade) return `${trade.buy ? 'Bought' : 'Sold'} ${amount(trade.tokens)} ${notice.symbol}${trade.usd[0] === undefined ? '' : ` · ${usd(trade.usd[0])}`}${notice.wallet_count[0] === undefined ? '' : ` · ${notice.wallet_count[0]} selected wallets`}`;
  return notice.progress_bps[0] === undefined ? notice.symbol : `${notice.symbol} reached ${notice.progress_bps[0] / 100}% of its curve`;
}
export async function closeBrowserPremiumAlerts(owner: string) {
  if (!('serviceWorker' in navigator)) return;
  const worker = await navigator.serviceWorker.getRegistration('/trader-alerts-sw.js');
  (await worker?.getNotifications() ?? []).filter(notice => notice.data?.account === owner && notice.data?.premium === true).forEach(notice => notice.close());
}
export async function showBrowserPremiumAlerts(owner: string, notices: PremiumNotification[], stillEligible: () => boolean) {
  if (!browserAlertsEnabled(owner) || !stillEligible()) return;
  const worker = await browserAlertsRegistration();
  for (const notice of [...notices].sort((a, b) => a.id < b.id ? -1 : 1)) {
    if (!stillEligible() || !browserAlertsEnabled(owner)) return;
    const deliver = async () => {
      const key = `soonscreener:last-browser-premium:${owner}`, last = localStorage.getItem(key);
      if (last && /^\d+$/.test(last) && BigInt(last) >= notice.id) return;
      if (!stillEligible() || !browserAlertsEnabled(owner)) return;
      await worker.showNotification(notice.rule_name, { body: premiumNoticeText(notice), icon: '/brand/owl.png', badge: '/brand/owl.png', tag: `soonscreener:premium:${owner}:${notice.id}`, data: { account: owner, premium: true, url: `/token/${notice.market.toText()}` } });
      if (!stillEligible() || !browserAlertsEnabled(owner)) { await closeBrowserPremiumAlerts(owner); return; }
      localStorage.setItem(key, notice.id.toString());
    };
    if ('locks' in navigator) await navigator.locks.request(`soonscreener-premium-alerts:${owner}`, deliver); else await deliver();
  }
}
